import type { Permission } from '@teachino/shared-util';
import { useGlobalDependencyProvider } from '@teachino/shared-util';
import { computed } from 'vue';
import { shouldShowProFeatureBadge } from './pro-feature-badge-visibility';
import { canUseProFeature } from './soft-paywall';
import { useLicense } from './useLicense';

/** Reactive Pro badge visibility for a gated feature (grace, trial, and license rules applied). */
export function useShowProFeatureBadge(feature: Permission) {
  const user = useGlobalDependencyProvider().inject('user');
  const { paywallLicenses } = useLicense();

  return computed(() => {
    const licenses = paywallLicenses.value;
    const canUse = canUseProFeature(
      feature,
      user.hasPermission(feature).value,
      licenses,
      user.accountCreatedAt.value,
    );

    return shouldShowProFeatureBadge(canUse, licenses);
  });
}
